export enum shapeType {
  Polygon = 0,
  Line = 1,
  Point = 2
}